import React from "react";

export default function JumbotronCariMobil() {
    return (
        <section className="custom-user-section1 py-5 mb-5">
            <div className="container py-5">
                <div className="row py-5">
                    <div className="col-md-6 d-flex align-items-center justify-content-center custom-user-cover">
                        <div>
                            <h2 className="font-weight-bold custom-user-head1">Sewa & Rental Mobil Terbaik di kawasan (Lokasimu)</h2>
            
                            <p className="custom-user-font">
                                Selamat datang di Binar Car Rental. Kami menyediakan mobil kualitas <br/> terbaik dengan harga terjangkau. Selalu siap melayani kebutuhanmu <br/> untuk sewa mobil selama 24 jam.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
